import { render, staticRenderFns } from "./WeedingDetails.vue?vue&type=template&id=3fd604c4&scoped=true&lang=html&"
import script from "./WeedingDetails.vue?vue&type=script&lang=js&"
export * from "./WeedingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd604c4",
  null
  
)

export default component.exports